import { FC } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { userApi } from '../api/user.api';
import Loading from '../components/common/loading/Loading';
import { WrapInLayout } from '../layouts';
import UserEditForm from '../components/users/UserEditForm';

const UserPage: FC = () => {
  let { idUser } = useParams();
  const navigate = useNavigate();
  const { data: user } = userApi.useGetUserQuery(idUser || '', { skip: !idUser });

  !idUser && navigate('/');  
  return (
    <WrapInLayout title={`User ${user?.email}`} layout="portal">
      {!user
        ? <Loading />
        : <UserEditForm user={user} showIntegrations />
      }
    </WrapInLayout>
  );
};

export default UserPage;
